<template lang="pug">
  
  .Table-filter
    .filter(
      v-for="(filter, index) in selectedFilters"
      :key="index")
      template(v-if="filter.type === BRANCH_TREE_ID")
        .title {{ filter.label }}
        .value {{ getBranchTreeNames(filter) }}
      template(v-else)
        .title {{ filter.label }}
        .value {{ filter.selectedItemsLabel }}
      button.remove.btn.btn-icon.btn-small(
      type="button"
      @click="onFilterClick(filter)")
        IconClose

</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'FilterShow',
    data() {
      return {
        BRANCH_TREE_ID: 12
      }
    },
    props: {
      filters: {
        type: Array,
        required: true
      }
    },
    watch: {
      filters() {
        console.log("filters change")
      }
    },
    computed: {
      ...mapState('Branch', [
        'branch_list'
      ]),

      selectedFilters() {
        return this.filters.filter(f => f.hasSelectedFilter)
      }
    },
    methods: {
      onFilterClick(filter) {
        this.$emit("clearFilter", filter)
      },

      getBranchTreeNames(filter) {
        let branch_list = []
        let stateBranchList = this.branch_list.list
        stateBranchList.map(sb => {
          sb.terminals.map(sbt => {
            branch_list.push({
              id: sbt.id,
              name: sb.name + ' - ' + sbt.name
            })
          })
        })
        let filtered_terminal_list = []
        branch_list.map(b => {
          filter.value.map(f => {
            if(b.id === f) {
              filtered_terminal_list.push(b.name)
            }
          })
        })
        return filtered_terminal_list.map(o => o).join(', ')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .Table-filter {
    display: flex;
    flex-wrap: wrap;
    font-size: $font-size-small;

    .filter {
      flex: 0 0 auto;
      margin-right: 10px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      padding-left: 15px;
      background-color: rgba($color-green, .2);
      border-radius: $border-radius;
      max-width: 100%;

      .title {
        font-weight: bold;
        margin-right: 10px;

        &:after {
          content: ":";
        }
      }

      .value {
        position: relative;
        top: -1px;
        padding-top: 5px;
        padding-bottom: 5px;
      }

      .remove {
        margin-left: 5px;
        color: $color-gray;
        background-color: transparent;
        box-shadow: none !important;
        border-color: transparent;

        &:hover {
          color: $color-navy;
        }

        .icon {
          width: 18px;
          height: 18px;
        }
      }

    }

  }
</style>
